module.exports = __webpack_public_path__ + "media/images/mamari/wowma/btn-download-yellow-14a0bd3423c5c2ef766db0b9efbe9f2e.png";